import { TaskType } from '../types/tasks.types';
import { ORDERS_ACTIONS } from './orders-actions';
import { TASKS_ACTIONS } from './tasks-actions';

export interface TaskTypeDefinition {
  /**
   * The app where the work is done, its NavBar name in kebab-case
   * (`orders`, `purchase-orders`): its tasks come first in that app.
   */
  app: string;
  /** Who sees the task: holders of this action in the store. */
  required_action: string;
}

/**
 * Every task type (docs/plans/orders-and-transfers.md §4.13). A producer
 * publishes the type; the list reads who sees it from here. Its title is
 * `taskTitle` in shared-ui (literal i18n keys).
 */
export const TASK_TYPES: Record<TaskType, TaskTypeDefinition> = {
  [TaskType.ORDER_PLAN]: {
    app: 'orders',
    required_action: ORDERS_ACTIONS.ORDER_PLAN,
  },
  [TaskType.TRANSFER_DISPATCH]: {
    app: 'orders',
    required_action: ORDERS_ACTIONS.TRANSFER_DISPATCH,
  },
  [TaskType.TRANSFER_RECEIVE]: {
    app: 'orders',
    required_action: ORDERS_ACTIONS.TRANSFER_RECEIVE,
  },
  [TaskType.ORDER_EXPIRING]: {
    app: 'orders',
    required_action: ORDERS_ACTIONS.ORDER_CREATE,
  },
  // By default only the Merchant role holds it: the owner decides.
  [TaskType.STOCK_OVERSOLD]: {
    app: 'products',
    required_action: ORDERS_ACTIONS.STOCK_RELEASE_ANY,
  },
  [TaskType.TRANSFER_RETURN]: {
    app: 'orders',
    required_action: ORDERS_ACTIONS.TRANSFER_RETURN,
  },
  [TaskType.TRANSFER_SETTLE]: {
    app: 'orders',
    required_action: ORDERS_ACTIONS.TRANSFER_RECONCILE,
  },
  [TaskType.PRICE_APPROVAL]: {
    app: 'orders',
    required_action: ORDERS_ACTIONS.PRICE_APPROVE,
  },
  [TaskType.INVENTORY_CHECK]: {
    app: 'products',
    required_action: ORDERS_ACTIONS.STOCK_COUNT,
  },
  // Always assigned to a person or a role, so no holder partition is read
  // for it; holders of `tasks:view_all` see it in the team view.
  [TaskType.MANUAL]: {
    app: 'tasks',
    required_action: TASKS_ACTIONS.VIEW_ALL,
  },
};

/** The task id of a manual task (`source_key`), from its client ULID. */
export const manualTaskId = (id: string) => `manual:${id}`;
